<template>
  <!-- 线下培训 -->
  <div class="wrapper main-container">
    <div class="content">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">培训专题</span>
          <Input v-model="searchParams.themeName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">培训老师</span>
          <Input v-model="searchParams.teachers" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">业务员工号</span>
          <Input v-model="searchParams.staffNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">开始时间</span>
          <DatePicker type="daterange" split-panels separator="至" v-model="searchParams.date" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="warning" @click="$refs.editForm.open()" v-show="$units.pointAction('operate_5_1')">新增专题</Button>
          <Button type="warning" @click="removalAll()">批量专题导入</Button>
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <div class="detail">
              <div @click="$refs.editForm.open(row)" v-show="$units.pointAction('operate_5_1')">
                <span>编辑</span>
              </div>
              <div @click="$refs.userDetail.open(row)" v-show="$units.pointAction('operate_5_2')">
                <span>业务员</span>
              </div>
              <div @click="del(row)" v-show="$units.pointAction('operate_5_3')">
                <span>删除</span>
              </div>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
    </div>
    <!-- 修改基本信息  -->
    <editForm ref="editForm" @suceess="searchAjax()"></editForm>
    <!-- 培训人员详情 -->
    <userDetail ref="userDetail" @suceess="searchAjax()"></userDetail>

    <import-tool ref="importTool" @success="searchAjax()"></import-tool>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import editForm from './components/edit';
import userDetail from './components/userDetail';
import importTool from '@/components/commons/importTool/index2';

export default {
  components: {
    editForm,
    importTool,
    userDetail
  },
  mixins: [pageTool],
  props: {},
  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '培训专题',
          key: 'themeName',
          align: 'center',
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            let text = params.row.themeName;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text || '-'
                ),
                h('span', { slot: 'content' }, text || '-')
              ]
            );
          }
        },
        {
          title: '培训简介',
          key: 'description',
          align: 'center',
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            let text = params.row.description;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text || '-'
                ),
                h('span', { slot: 'content' }, text || '-')
              ]
            );
          }
        },
        {
          title: '培训老师',
          key: 'teachers',
          align: 'center',
          minWidth: 120
        },
        {
          title: '培训地址',
          key: 'address',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let text = params.row.address;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: '开始时间',
          key: 'startTime',
          width: '160',
          align: 'center',
          render(h, params) {
            const date = params.row.startTime.substring(0, 16);
            return <span>{date}</span>;
          }
        },
        {
          title: '结束时间',
          key: 'endTime',
          width: '160',
          align: 'center',
          render(h, params) {
            const date = params.row.endTime.substring(0, 16);
            return <span>{date}</span>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '200',
          fixed: 'right'
        }
      ]
    };
  },
  activated(){
    this.getList()
  },
  mounted() {
    if (!this.$units.pointAction('operate_5_1') && !this.$units.pointAction('operate_5_2') && !this.$units.pointAction('operate_5_3')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.initListAjax('/buz/train/read/list');
  },
  methods: {
    removalAll() {
      const dic = JSON.parse(localStorage.dic)['TRAIN_BATCH_UPDATE_EXPORT'];
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params: {},
        uploadParams: {},
        template: key,
        // template:'https://file.lazhuyun.cn/upload/doc/2023/10/18/1697628819259309998.xls',
        templateName: dic[key],
        uploadUrl: '/buz/train/importTrain'
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'operate_5_0';
    },
    // 转化参数
    setListParams(params) {
      if (params.date && params.date[0]) {
        params.startTimeBegin = this.$units.formatDate(params.date[0]);
        params.startTimeEnd = this.$units.formatDate(params.date[1]);
      }
      delete params.date;
    },
    // 删除
    del(row) {
      this.$notice.inquiry('确定删除？').then(() => {
        this.$http({
          url: '/buz/train/del',
          type: 'get',
          data: {
            id: row.id
          },
          apiPermissionCode: 'operate_5_3'
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList();
        });
      });
    },
    // 导出合同
    daochu(row) {
      this.listLoading = true;
      this.$http({
        type: 'GET',
        forced: true,
        responseType: 'blob',
        All: true,
        url: `/buz/userContract/downloadZip`,
        data: {
          id: row.id
        }
      })
        .then(res => {
          this.$units.daochu(res);
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  .label {
    font-size: 13px;
  }
  /deep/ .ivu-input {
    font-size: 13px;
  }
  /deep/ .ivu-select-selected-value {
    font-size: 13px;
  }
  .ivu-btn {
    font-size: 13px;
  }
}
.detail span {
  font-size: 13px;
}
</style>
